<document-lines-editor
  #lineGrid
  [columnDefs]="columnDefs"
  [rows]="lines"
  [onCellValueChanged]="onCellValueChanged"
  [treeData]="true"
  [getDataPath]="getDataPath"
  [chapterLineRole]="chapterLineRole"
  [getContextMenuItems]="getContextMenuItems"
  [pinnedBottomRowData]="pinnedBottomRowData"
  [rowClassRules]="rowClassRules"
  [isDialogBox]="true"
  [fillRemainingHeight]="false"
  [domLayout]="'autoHeight'"
  gridStateKey="deliveryNoteCreationGrid"
>
</document-lines-editor>
